{
	"openingProject": "Opening project..."
}
